import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { Toaster } from "sonner";
import axios from "axios";

// Add axios interceptor to handle token expiration
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error.response?.status;
    const detail = error.response?.data?.detail;

    if (status === 401) {
      // Only force logout for real auth problems, not every 401
      const authErrors = [
        "Token expired",
        "Invalid token",
        "Invalid authentication",
        "User not found",
      ];

      if (detail && authErrors.includes(detail)) {
        // Prefer using refresh token to silently renew the session before forcing logout
        const refreshToken = localStorage.getItem("refresh_token");
        if (refreshToken && !window.location.pathname.startsWith("/login")) {
          const formData = new FormData();
          formData.append("refresh_token", refreshToken);

          return axios
            .post(`${process.env.REACT_APP_BACKEND_URL}/api/auth/refresh`, formData)
            .then((resp) => {
              if (resp.data?.access_token && resp.data?.refresh_token) {
                localStorage.setItem("access_token", resp.data.access_token);
                localStorage.setItem("refresh_token", resp.data.refresh_token);
                if (resp.data.user) {
                  localStorage.setItem("user", JSON.stringify(resp.data.user));
                }
                // Retry original request with new token
                const originalRequest = error.config;
                originalRequest.headers = originalRequest.headers || {};
                originalRequest.headers["Authorization"] = `Bearer ${resp.data.access_token}`;
                return axios(originalRequest);
              }
              throw new Error("Invalid refresh response");
            })
            .catch(() => {
              localStorage.removeItem("access_token");
              localStorage.removeItem("refresh_token");
              localStorage.removeItem("user");
              if (window.location.pathname !== "/login") {
                window.location.href = "/login?expired=true";
              }
              return Promise.reject(error);
            });
        }

        localStorage.removeItem("access_token");
        localStorage.removeItem("refresh_token");
        localStorage.removeItem("user");
        if (window.location.pathname !== "/login") {
          window.location.href = "/login?expired=true";
        }
      }
    }

    return Promise.reject(error);
  }
);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
    <Toaster position="top-right" richColors />
  </React.StrictMode>
);